import { navigate } from "../../../../service/navigation/Navigation";
import { appRoutes } from "../../../../routes/routes";
import ApiUrls from "../../../../service/api/ApiUrls";
import ApiService from "../../../../service/api/ApiService";
import SessionStorage from "../../../../service/storage/SessionStorage";
import StorageKeys from "../../../../const/StorageKeys";
import ShowToast from "../../../../widget/common/ui/Toast";

const NewPasswordProfileProvider = new (class NewPasswordProfileProvider {
  navigateLogin = () => {
    navigate(appRoutes.routeNameLogin, { replace: true });
  };

  submitPasswordAPI = async (params: {
    profileId: string;
    resetCode: string;
    password: string;
  }): Promise<boolean> => {
    ApiUrls.init();

    const url: string = `${ApiUrls.baseUrl}profile/reset_password`;
    const body: any = {
      profile_id: params.profileId,
      reset_code: params.resetCode,
      password: params.password,
    };

    const response: any = await ApiService.postApi(url, body);
    if (response != null) {
      if (response["success"] === "1") {
        SessionStorage.deleteValue(StorageKeys.recover_password_detail);

        return true;
      } else {
        ShowToast.error(response["errorMessage"]);
      }
    }

    return false;
  };
})();

export default NewPasswordProfileProvider;
